module.exports = __webpack_public_path__ + "static/media/katy-perry.f9a80496.jpg";